import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faShop } from "@fortawesome/pro-light-svg-icons"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import {
    SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_CREATE_ROUTE,
    SUPPLIER_ADMIN_ROUTE,
} from "../../../../../../constants/routes"
import React, { Suspense } from "react"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import { QueryErrorBoundary } from "../../../../../../core/api/components/QueryErrorBoundary"
import { TermsAndConditionsTable } from "../components/TermsAndConditionsTable"
import { LoadingSpinner } from "../../../../../../shared/components/loading/LoadingSpinner"
import { useNavigate } from "react-router-dom"

type Props = Readonly<{}>

export function TermsAndConditionsList({}: Props) {
    const navigate = useNavigate()

    return (
        <>
            <LocalizedStrict id="supplier-admin-settings-terms-and-conditions" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SUPPLIER_TERMS_AND_CONDITIONS}
                    title="Terms and conditions"
                    icon={<FontAwesomeIcon icon={faShop} />}
                    rightElement={
                        <LocalizedStrict id="supplier-admin-settings-terms-and-conditions-list-create-button">
                            <StandardButton
                                onClick={() => navigate(SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_CREATE_ROUTE)}
                            >
                                Create new
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="supplier-nav-item-home">
                            <BreadcrumbLink to={SUPPLIER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-settings">
                            <Breadcrumb>Settings</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-terms-and-conditions">
                            <Breadcrumb>Terms and conditions</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <QueryErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                    <TermsAndConditionsTable />
                </Suspense>
            </QueryErrorBoundary>
        </>
    )
}
